module.exports = __webpack_public_path__ + "static/media/epillax-4.d6f32d6e.jpg";